
import BluetoothCircle from "../../../assets/outline/BluetoothCircle.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BluetoothCircleIcon({ className, dataTestid = "BluetoothCircleIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <BluetoothCircle data-testid={dataTestid} className={classes} {...rest} />
  );
}
